import "./frame.component.css";

/**
 * @param width optional;
 * @param image optional;
 * @param title optional; top & bottom (use \n for line break)
 * @param text optional; (use \n for line break)
 * @param notRevealed optional;
 * @param className Further class names
 * @param key Further keys
 * @return Example component
 */
function FrameComponent(
    props: Readonly<{
        width?: string,
        image?: string,
        title?: {
            top?: string,
            bottom?: string,
        },
        text?: string,

        notRevealed?: boolean,

        className?: string,
        [key: string]: any
    }>
) {
    const { width, image, title, text, notRevealed, className, ...overflowProps } = props;

    const finalWidth = width ?? "100%";
    const borderSize = 5;

    return <div
        className={`frame-component ${className ?? ""} ${notRevealed ? "not-revealed" : ""} no-select`}
        {...overflowProps}
        style={{
            width: finalWidth,
            paddingTop: borderSize,
            paddingBottom: borderSize,
        }}
    >
        <div
            className="content"
            style={{
                width: `calc(${finalWidth} - ${borderSize * 2}px - var(--size-m) * 2)`
            }}
        >
            {/* IMAGE */}
            {image && <div className="flex center no-select">
                <img src={image} alt="frame symbol" height={130} />
            </div>}

            {/* TITLE */}
            {title && <div className="title-container">
                {notRevealed && <h3 className="nr-text"></h3>}
                {title?.top && (
                    <h2 className="title">
                        {title.top.split("\n").map((line, i) => (
                            <span key={i}>
                                {line}
                                <br />
                            </span>
                        ))}
                    </h2>
                )}
                {title?.bottom && <h2 className="bottom">{title?.bottom}</h2>}
            </div>}

            {/* TEXT */}
            {text && <p>{text}</p>}
        </div>
    </div>
}

export default FrameComponent;